import { Col } from "antd";
import React from "react";
import Header from "../Authorized/Header";
import HomeContent from "./HomeContent";

const HomePage = () => {
  return (
    <Col xs={{ span: 24 }}>
      <Header />
      <HomeContent />
    </Col>
  );
};

export default HomePage;
